export default __webpack_public_path__ + "static/media/miguel-lopes-17.c49090ce.jpg";